import { render, staticRenderFns } from "./ActivityOpenQuestion.vue?vue&type=template&id=f9cbbc7e&scoped=true&"
import script from "./ActivityOpenQuestion.vue?vue&type=script&lang=js&"
export * from "./ActivityOpenQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ActivityOpenQuestion.vue?vue&type=style&index=0&id=f9cbbc7e&lang=scss&scoped=true&"
import style1 from "./ActivityOpenQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cbbc7e",
  null
  
)

export default component.exports